var module = angular.module('main.resellerorder', []);

module.component('readonlyResellerOrderHeader',{
    templateUrl: 'main/resellerorder/genericcomponents/readonlyorderheader.cmp.tpl.html',
    bindings: {
        resellerOrder: '<',
        initCollapsed: '<'
    },
    controllerAs: 'vm',
    controller: ['$translate', 'updateAddressDialogService', 'ResellerOrdersApiService', 'ToasterService', componentController]
});

// @ngInject
function componentController($translate, updateAddressDialogService, ResellerOrdersApiService, ToasterService) {
    var vm = this;

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    //Properties
    vm.collapseHeader = vm.initCollapsed ? vm.initCollapsed : true;

    //Methods
    vm.formatAddress = formatAddress;
    vm.formatCityAndCountry = formatCityAndCountry;
    vm.isTheSameAddresses = isTheSameAddresses;
    vm.getStatusTranslation = getStatusTranslation;
    vm.isTheSameAddresses = isTheSameAddresses;
    vm.canSetOrderDeliveryAddress = canSetOrderDeliveryAddress;
    vm.setOrderDeliveryAddress = setOrderDeliveryAddress;
    vm.canSetOrderInvoiceAddress = canSetOrderInvoiceAddress;
    vm.setOrderInvoiceAddress = setOrderInvoiceAddress;

    function onInit() {
    }
    function onChanges() {
        console.log('ResellerOrderHeader, resellerOrder', vm.resellerOrder);
    }

    function canSetOrderDeliveryAddress() {
        var hasLink = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'confirm'; }) !== undefined;
        return hasLink;
    }
    function setOrderDeliveryAddress() {
        var requestAddress = {
            addressLine1: vm.resellerOrder.deliveryAddress.addressLine1,
            addressLine2: vm.resellerOrder.deliveryAddress.addressLine2,
            addressLine3: vm.resellerOrder.deliveryAddress.addressLine3,
            city: vm.resellerOrder.deliveryAddress.city,
            country: vm.resellerOrder.deliveryAddress.country,
            postalCode: vm.resellerOrder.deliveryAddress.zipCode
        };
        updateAddressDialogService.showDialog($translate.instant('resellerorder.deliveryadress'), requestAddress).then(function (result) {
            if (result.isCompleted === true) {
                var request = {
                    orderId: vm.resellerOrder.id,
                    address: {
                        addressLine1: result.address.addressLine1,
                        addressLine2: result.address.addressLine2,
                        addressLine3: result.address.addressLine3,
                        city: result.address.city,
                        country: result.address.country,
                        postalCode: result.address.postalCode
                    }
                };
                ResellerOrdersApiService.setOrderDeliveryAddress(request).then(function(response) {
                    vm.resellerOrder.deliveryAddress.addressLine1 = request.address.addressLine1;
                    vm.resellerOrder.deliveryAddress.addressLine2 = request.address.addressLine2;
                    vm.resellerOrder.deliveryAddress.addressLine3 = request.address.addressLine3;
                    vm.resellerOrder.deliveryAddress.city = request.address.city;
                    vm.resellerOrder.deliveryAddress.country = request.address.country;
                    vm.resellerOrder.deliveryAddress.zipCode = request.address.postalCode;
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, error.message);
                }).finally(function() {
                });
            }
        });
    }
    function canSetOrderInvoiceAddress() {
        var hasLink = _.find(vm.resellerOrder.links, function(o) { return o.rel === 'confirm'; }) !== undefined;
        return hasLink;
    }
    function setOrderInvoiceAddress() {
        var requestAddress = {
            addressLine1: vm.resellerOrder.invoiceAddress.addressLine1,
            addressLine2: vm.resellerOrder.invoiceAddress.addressLine2,
            addressLine3: vm.resellerOrder.invoiceAddress.addressLine3,
            city: vm.resellerOrder.invoiceAddress.city,
            country: vm.resellerOrder.invoiceAddress.country,
            postalCode: vm.resellerOrder.invoiceAddress.zipCode
        };
        updateAddressDialogService.showDialog($translate.instant('resellerorder.invoiceaddress'), requestAddress).then(function (result) {
            if (result.isCompleted === true) {
                var request = {
                    orderId: vm.resellerOrder.id,
                    address: {
                        addressLine1: result.address.addressLine1,
                        addressLine2: result.address.addressLine2,
                        addressLine3: result.address.addressLine3,
                        city: result.address.city,
                        country: result.address.country,
                        postalCode: result.address.postalCode
                    }
                };
                ResellerOrdersApiService.setOrderInvoiceAddress(request).then(function(response) {
                    vm.resellerOrder.invoiceAddress.addressLine1 = request.address.addressLine1;
                    vm.resellerOrder.invoiceAddress.addressLine2 = request.address.addressLine2;
                    vm.resellerOrder.invoiceAddress.addressLine3 = request.address.addressLine3;
                    vm.resellerOrder.invoiceAddress.city = request.address.city;
                    vm.resellerOrder.invoiceAddress.country = request.address.country;
                    vm.resellerOrder.invoiceAddress.zipCode = request.address.postalCode;
                }, function(error) {
                    var message = error.message + '\n';
                    _.forEach(error.errors, function(err) {
                        message += err.message + '\n';
                    });
                    ToasterService.showError(message, error.message);
                }).finally(function() {
                });
            }
        });
    }

    function getStatusTranslation(text) {
        if (text) {
            var textCapital = text.substr(0, 1).toUpperCase() + text.substr(1, text.length - 1);
            return $translate.instant('resellerorder.status' + textCapital);
        }
    }

    function formatAddress(address) {
        if (!address) {
            return "";
        }
        var strings = [];
        var result = "";
        if (address.addressLine1) {
            strings.push(address.addressLine1);
        }
        if (address.addressLine2) {
            strings.push(address.addressLine2);
        }
        if (address.addressLine3) {
            strings.push(address.addressLine3);
        }
        result = strings.join(', ');
        return result;
    }

    function formatCityAndCountry(address) {
        if (!address) {
            return "";
        }
        var strings = [];
        var result = "";
        if (address.postalCode) {
            strings.push(address.postalCode);
        }
        if (address.city) {
            strings.push(address.city);
        }
        if (address.country) {
            strings.push(address.country);
        }
        result = strings.join(', ');
        return result;
    }

    function isTheSameAddresses(address1, address2) {
        return address1.addressLine1 === address2.addressLine1 &&
               address1.addressLine2 === address2.addressLine2 &&
               address1.addressLine3 === address2.addressLine3 &&
               address1.postalCode === address2.postalCode &&
               address1.city === address2.city &&
               address1.postalCode === address2.postalCode;
    }
}
